import styled, { css } from 'styled-components';
import { WrapperProps, TooltipTextProps, Placement } from './types';

export const TooltipText = styled.span.attrs({
  'data-testid': 'tooltip-balloon',
})<TooltipTextProps>`
  bottom: calc(100% + 10px);
  ${({ $placement = 'center' }) => placementMap[$placement]}
  max-width: min(${({ $width }) => $width}, calc(100vw - ${({ theme }) =>
    theme.spacing.km8}));
  width: max-content;
  display: none;
  background-color: ${({ theme }) => theme.color.background.neutral.inverted};
  text-align: center;
  border-radius: ${({ theme }) => theme.border.radius.large};
  padding: ${({ theme }) => theme.spacing.km3};
  position: absolute;
  z-index: 1;
  letter-spacing: -0.03em;
`;

const placementMap: Record<Placement, ReturnType<typeof css>> = {
  left: css`
    left: -8px;
  `,
  center: css`
    left: 50%;
    transform: translateX(-50%);
  `,
  right: css`
    right: -8px;
  `,
};

export const Wrapper = styled.div.attrs({
  'data-testid': 'tooltip',
})<WrapperProps>`
  position: relative;
  display: inline-block;
  cursor: pointer;

  &:hover {
    &::before {
      content: '';
      position: absolute;
      bottom: calc(100% + 4px);
      left: 50%;
      right: 50%;
      width: 14px;
      height: 14px;
      background-color: ${({ theme }) =>
        theme.color.background.neutral.inverted};
      border-radius: 2px;
      transform: translateX(-50%) rotateZ(45deg);
    }
    ${TooltipText} {
      display: block;
    }
  }
`;

export const Text = styled.p`
  color: ${({ theme }) => theme.color.text.neutral.inverted};
  font-size: ${({ theme }) => theme.font.size.m3};
  line-height: ${({ theme }) => theme.font.lineHeight.small};
  font-weight: ${({ theme }) => theme.font.weight.medium};
  text-align: center;
`;
